import { useMemo } from "react";
import { motion } from "framer-motion";

export const CoinShower = ({ count = 18 }) => {
  const coins = useMemo(() => Array.from({ length: count }, (_, i) => ({
    id: i,
    left: Math.random() * 100,
    delay: Math.random() * 0.6,
    dur: 1.1 + Math.random() * 0.9,
    size: 16 + Math.random() * 18,
    spin: Math.random() > 0.5 ? 720 : -720,
  })), [count]);
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none" data-testid="coin-shower">
      {coins.map((c) => (
        <motion.div
          key={c.id}
          initial={{ y: -60, rotateY: 0, opacity: 1 }}
          animate={{ y: 420, rotateY: c.spin, opacity: [1, 1, 0.8] }}
          transition={{ duration: c.dur, delay: c.delay, ease: "easeIn" }}
          className="absolute rounded-full flex items-center justify-center font-bold text-[#7a4f00]"
          style={{
            left: `${c.left}%`, width: c.size, height: c.size, fontSize: c.size * 0.55,
            background: "radial-gradient(circle at 35% 30%, #FFF1C1, #F2C462 45%, #B8862B 100%)",
            boxShadow: "0 0 10px rgba(242,196,98,0.8), inset 0 -2px 0 rgba(0,0,0,0.25)",
          }}
        >$</motion.div>
      ))}
    </div>
  );
};
